'use strict';exports.__esModule = true;exports.resetGeocodedPlace = exports.receiveGeocodedPlace = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _constants = require('../../constants');
var _axiosConfig = require('../../helpers/axiosConfig');var _axiosConfig2 = _interopRequireDefault(_axiosConfig);
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var receiveGeocodedPlace = (0, _reduxAct.createAction)('/GEOCODED_PLACE');
var receiveGeocodedPlaceSuccess = (0, _reduxAct.createAction)('/GEOCODED_PLACE_SUCCESS');
var receiveGeocodedPlaceFail = (0, _reduxAct.createAction)('/GEOCODED_PLACE_FAIL');
var resetGeocodedPlace = (0, _reduxAct.createAction)('/RESET_GEOCODED_PLACE');

var initialState = {
  loading: false,
  loaded: false,
  error: null,
  geocodedPlace: undefined };


var handleReceiveGeocodedPlaceSuccess = function handleReceiveGeocodedPlaceSuccess(state, response) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    geocodedPlace: response.data });};


var handleReceiveGeocodedPlaceFail = function handleReceiveGeocodedPlaceFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while receiving geocoded place');
  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    geocodedPlace: undefined,
    error: error });

};

var handleResetGeocodedPlace = function handleResetGeocodedPlace(state) {return Object.assign({},
  state,
  initialState);};


var fetchReceive = function fetchReceive(params) {return _axios2.default.get(_constants.locationsApiURL + '/places/geocode', { params: params }).
  then(receiveGeocodedPlaceSuccess, receiveGeocodedPlaceFail);};

var handleReceiveGeocodedPlace = function handleReceiveGeocodedPlace(state, data) {return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true, error: null }), promise(fetchReceive, data)));};

var placesGeocode = (0, _reduxAct.createReducer)(function (on) {
  on(receiveGeocodedPlace, handleReceiveGeocodedPlace);
  on(receiveGeocodedPlaceSuccess, handleReceiveGeocodedPlaceSuccess);
  on(receiveGeocodedPlaceFail, handleReceiveGeocodedPlaceFail);
  on(resetGeocodedPlace, handleResetGeocodedPlace);
}, initialState);exports.


receiveGeocodedPlace = receiveGeocodedPlace;exports.
resetGeocodedPlace = resetGeocodedPlace;exports.default =


placesGeocode;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/placesGeocode.js
// module id = 395
// module chunks = 0